import { Bar } from "../data/bars"
import { Badge, barBadges } from "../data/badges"

export const getAverageStar = (bar: Bar) => {
  if (!bar || !bar.info) return 0
  const values = Object.values(bar.info.ratings)
  const total = values.reduce(
    (accumulator, currentValue) => accumulator + currentValue,
    0
  )
  const valuesExist = values.filter((value) => value)
  const average = Math.round(total / valuesExist.length)
  return average
}

export const getBarBadges = (bar: Bar) => {
  if (!bar || !bar.info) return [] as Badge[]
  const badges = bar.info.badges?.map((badgeId) => {
    const badge = barBadges.find((badge: Badge) => badge.id === badgeId)
    return badge ? badge : null
  })
  return badges.filter((_) => _) as Badge[]
}
